/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import InfoHero from '../../components/heros/information';
import Footer from '../../components/footer';
// Images
import Tebex from '../../assets/images/partners/tebex.svg';
import AfterHours from '../../assets/images/partners/after_hours.svg';
import Rogues from '../../assets/images/partners/rogues.svg';
import Slime from '../../assets/images/partners/slime.svg';
import Discord from '../../assets/images/icons/discord.svg';
import Twitter from '../../assets/images/icons/twitter.svg';
import Youtube from '../../assets/images/icons/youtube.svg';
import Instagram from '../../assets/images/icons/Instagram.svg';
import Facebook from '../../assets/images/icons/Facebook.svg';
import Link from '../../assets/images/icons/link.svg';
import Hexigon from '../../assets/images/partner.svg';
import Card from '../../assets/images/affiliates/card.svg';
import MoneyHand from '../../assets/images/icons/money_hand.svg';
import g3n3zis from '../../assets/images/partners/g3n3zis.svg';

const Partners = () => {
    return (
        <main>
            <InfoHero title='Partners' description='Take a look at our beloved partners' />
            <section className='partners py-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                <div className='primary-gradient px-6 sm:px-6 md:px-6 lg:px-16 rounded-xl pt-16 pb-28'>
                    <div className='grid grid-cols-1 gap-9'>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-3 items-center'>
                                <div className='flex flex-wrap justify-center md:justify-start items-center mb-5 sm:mb-5 md:mb-5 lg:mb-5 xl:mb-0'>
                                    <div className='w-full sm:w-auto'>
                                        <img src={Tebex} alt="Tebex" className='mx-auto md:mx-0 mb-4 md:mb-0' />
                                    </div>
                                    <h1 className='text-gray-100 font-semibold text-2xl ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-16'>Tebex</h1>
                                </div>
                                <div className='col-span-2'>
                                    <div className='flex items-center justify-center md:justify-end'>
                                        <a href="https://affiliate.tebex.io/r/fe5d6f00-e01d-462b-ac50-7ef9c88828e8" target="_blank">
                                            <img src={Link} alt="Link" className='w-12' />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-3 items-center'>
                                <div className='flex flex-wrap justify-center md:justify-start items-center mb-5 sm:mb-5 md:mb-5 lg:mb-5 xl:mb-0'>
                                    <div className='w-full sm:w-auto'>
                                        <img src={Rogues} alt="Rogues" className='mx-auto md:mx-0 mb-4 md:mb-0' />
                                    </div>
                                    <h1 className='text-gray-100 font-semibold text-2xl ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-16'>Rogues</h1>
                                </div>
                                <div className='col-span-2'>
                                    <div className='flex items-center justify-center md:justify-end'>
                                        <a href="https://roguesnation.com/" target="_blank" className='mr-3'>
                                            <img src={Link} alt="Link" className='w-12' />
                                        </a>
                                        <a href="https://twitter.com/Rogues_Network" target="_blank" className='mr-3'>
                                            <img src={Twitter} alt="Twitter" className='w-12' />
                                        </a>
                                        <a href="https://discord.com/invite/uwaWEmj" target="_blank">
                                            <img src={Discord} alt="Discord" className='w-12' />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-3 items-center'>
                                <div className='flex flex-wrap justify-center md:justify-start items-center mb-5 sm:mb-5 md:mb-5 lg:mb-5 xl:mb-0'>
                                    <div className='w-full sm:w-auto'>
                                        <img src={Slime} alt="Slime" className='mx-auto md:mx-0 mb-4 md:mb-0' />
                                    </div>
                                    <h1 className='text-gray-100 font-semibold text-2xl ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-16'>Slimebot</h1>
                                </div>
                                <div className='col-span-2'>
                                <div className='flex items-center justify-center md:justify-end'>
                                        <a href="https://slimebot.xyz/" target="_blank" className='mr-3'>
                                            <img src={Link} alt="Link" className='w-12' />
                                        </a>
                                        <a href="https://discord.gg/hnRehDc2dW" target="_blank">
                                            <img src={Discord} alt="Discord" className='w-12' />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-3 items-center'>
                                <div className='flex flex-wrap justify-center md:justify-start items-center mb-5 sm:mb-5 md:mb-5 lg:mb-5 xl:mb-0'>
                                    <div className='w-full sm:w-auto'>
                                        <img src={g3n3zis} alt="g3n3zis" className='mx-auto md:mx-0 mb-4 md:mb-0' />
                                    </div>
                                    <h1 className='text-gray-100 font-semibold text-2xl ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-16'>G3n3zis</h1>
                                </div>
                                <div className='col-span-2'>
                                <div className='flex items-center justify-center md:justify-end'>
                                        <a href="https://www.g3n3zis.com/" target="_blank" className='mr-3'>
                                            <img src={Link} alt="Link" className='w-12' />
                                        </a>
                                        <a href="https://www.instagram.com/g3n3zis1" target="_blank" className='mr-3'>
                                            <img src={Instagram} alt="Instagram" className='w-12' />
                                        </a>
                                        <a href="https://www.facebook.com/g3n3zis1" target="_blank">
                                            <img src={Facebook} alt="Facebook" className='w-12' />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-3 items-center'>
                                <div className='flex flex-wrap justify-center md:justify-start items-center mb-5 sm:mb-5 md:mb-5 lg:mb-5 xl:mb-0'>
                                    <div className='w-full sm:w-auto'>
                                        <img src={AfterHours} alt="After Hours" className='mx-auto md:mx-0 mb-4 md:mb-0' />
                                    </div>
                                    <h1 className='text-gray-100 font-semibold text-2xl ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-16'>After Hours</h1>
                                </div>
                                <div className='col-span-2'>
                                    <div className='flex items-center justify-center md:justify-end'>
                                        <a href="https://discord.com/invite/qukTpR2Gd3/" target="_blank">
                                            <img src={Discord} alt="Discord" className='w-12' />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='more-info py-28'>
                <div className='content bg-primary py-20'>
                    <div className='grid grid-cols-1 lg:grid-cols-2 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 py-16'>
                        <div>
                            <h1 className='text-gray-100 text-3xl font-semibold mb-7 text-center lg:text-left'>Our Typical Partner</h1>
                            <p className='text-gray-300 text-xl text-center lg:text-left'>These are a estimate of what we are looking for in our partners.</p>
                        </div>
                    </div>
                </div>
                <div className='hidden lg:block max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                    <img src={Hexigon} alt="Hexigon Image" className='ml-auto' Style='margin-top: -520px;' />
                </div>
            </section>
            <section className='benefits py-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5'>
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Program Benefits</h1>
                    <p className="text-gray-300 text-center">Benefits of being partnered with Cyperhost are indivual, but this is what most can expect.</p>
                </div>
                <div className='body'>
                    <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-x-5 gap-y-10 mb-20'>
                        <div>
                        </div>
                        <div>
                            <img src={MoneyHand} alt="Discount Icon" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 text-lg font-semibold'>Discount Code</h1>
                        </div>
                        <div>
                            <img src={Card} alt="Server Icon" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 text-lg font-semibold'>Free Server</h1>
                        </div>
                        <div>
                        </div>
                    </div>
                    <div className='flex justify-center'>
                        <a href="https://client.cyperhost.com/submitticket.php" className='bg-primary px-20 py-4 rounded-lg text-gray-300 font-semibold'>Apply Now!</a>
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    )
}

export default Partners